import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import UserList, { ListOptions } from "./UserList";
import UserEdit from "./UserEdit";
import { isAdministrator } from "../../utils/roles";
import { MDSplitView } from "@solsys/solsys-reactjs";

export default function UserController({
  navigate,
  action,
  id,
  search,
  style,
  options = {},
}) {
  const { user } = useAuth();
  const isAdmin = isAdministrator(user);

  let listState = {
    [ListOptions.roleFilter]: null,
  };
  const didMount = useRef(false);
  useEffect(() => (didMount.current ? undefined : (didMount.current = true)));
  if (!didMount.current && Object.keys(search).length) {
    Object.keys(ListOptions).forEach((key) => {
      if (search[key] !== undefined) listState[key] = search[key];
    });
  }
  listState = useState(listState);

  if (!isAdmin) {
    return (
      <div style={{ padding: 20 }}>
        <p>Administrator access required to manage users.</p>
      </div>
    );
  }

  return (
    <div className="users">
      <MDSplitView
        globalName="UserMDV"
        style={style}
        action={action}
        master={({ isNarrow, autoSelect }) => (
          <UserList
            isMaster
            state={listState}
            id={id}
            action={action}
            onStateChange={(state) => {
              navigate({ action, id, search: state, push: false });
            }}
            onSelect={(newId, userInteraction) => {
              if (
                newId &&
                id &&
                String(newId) === String(id) &&
                userInteraction
              ) {
                navigate({
                  popOut: isNarrow,
                  action: "list",
                  id: null,
                  search: listState[0],
                });
              } else {
                navigate({
                  popOut: isNarrow,
                  ...(newId === 0
                    ? { action: "add", id: null }
                    : { action: "edit", id: newId }),
                  search: listState[0],
                });
              }
            }}
          />
        )}
        detail={() => (
          <UserEdit
            key={`action_${action}_id_${id}`}
            id={id}
            action={action}
            navigate={navigate}
          />
        )}
        initialWidth={300}
        maxWidth={800}
        minWidth={290}
      />
    </div>
  );
}
